import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from '../network/Configurations';

const assignLabelToArtist = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ASSIGN_LABEL, {}, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const markArtistVerified = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.MARK_USER_VERIFIED, {}, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const addArtist = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.post(API_URL.ADD_USER, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const updateArtist = (request: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.UPDATE_USER, request)
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const deleteArtists = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.delete(API_URL.DELETE_USER_PROFILES, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const markArtistShowcase = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.put(API_URL.MARK_USER_SHOWCASE, {}, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getArtistById = (params: any): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_PROFILE_BY_ID, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getArtistList = (params): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(`${API_URL.GET_USERS_LIST}?categoryType=Artist`, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getArtistAuditionList = (params): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(API_URL.GET_USER_AUDITIONS, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getImagesList = (params): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(`${API_URL.GET_USERS_MEDIA}?mediaType=Image`, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getVideoList = (params): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(`${API_URL.GET_USERS_MEDIA}?mediaType=Video`, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

const getAudioList = (params): Promise => {
    return new Promise((resolve, reject) => {
        trackPromise(
            axiosBridge.get(`${API_URL.GET_USERS_MEDIA}?mediaType=Audio`, { params })
                .then(response => {
                    if (response.data.code === StatusCodes.SUCCESS || response.data.code === StatusCodes.NO_DATA_FOUND) {
                        resolve(response.data)
                    } else reject(response.data)
                })
                .catch((error) => {
                    reject(error);
                })
        );
    });
}

export const ArtistService = {
    assignLabelToArtist,
    markArtistVerified,
    addArtist,
    updateArtist,
    deleteArtists,
    markArtistShowcase,
    getArtistById,
    getArtistList,
    getArtistAuditionList,
    getImagesList,
    getVideoList,
    getAudioList
}